import API_BASE_URL from '../config/api';

const jsonHeaders = {
  'Content-Type': 'application/json',
};

export async function register(payload) {
  const res = await fetch(`${API_BASE_URL}/auth/register`, {
    method: 'POST',
    headers: jsonHeaders,
    credentials: 'include',
    body: JSON.stringify(payload),
  });
  const data = await res.json();
  if (!res.ok) {
    const msg =
      data?.message || data?.errors?.[0]?.msg || 'Registration failed';
    throw new Error(msg);
  }
  if (data?.token) localStorage.setItem('token', data.token);
  return data;
}

export async function login(payload) {
  const res = await fetch(`${API_BASE_URL}/auth/login`, {
    method: 'POST',
    headers: jsonHeaders,
    credentials: 'include',
    body: JSON.stringify(payload),
  });
  const data = await res.json();
  if (!res.ok) {
    const msg =
      data?.message || data?.errors?.[0]?.msg || 'Invalid credentials';
    throw new Error(msg);
  }
  if (data?.token) localStorage.setItem('token', data.token);
  return data;
}

export async function logout() {
  const token = localStorage.getItem('token');
  const res = await fetch(`${API_BASE_URL}/auth/logout`, {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    credentials: 'include',
  });
  // Best-effort: clear token regardless of response
  localStorage.removeItem('token');
  if (!res.ok) {
    try {
      const data = await res.json();
      throw new Error(data?.message || 'Logout failed');
    } catch (e) {
      // ignore parse errors
    }
  }
  return { success: true };
}

export async function getMe() {
  const token = localStorage.getItem('token');
  const res = await fetch(`${API_BASE_URL}/auth/me`, {
    method: 'GET',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    credentials: 'include',
  });
  let data = null;
  try {
    data = await res.json();
  } catch (_) {}
  if (!res.ok) {
    const msg = data?.message || 'Not authenticated';
    // Clear bad/expired token to avoid invalid signature loops
    if (
      res.status === 401 ||
      /invalid signature|jwt|expired/i.test(String(msg))
    ) {
      localStorage.removeItem('token');
      return null;
    }
    throw new Error(msg);
  }
  return data?.data || null;
}

export async function updateMe(payload) {
  const token = localStorage.getItem('token');
  const res = await fetch(`${API_BASE_URL}/auth/me`, {
    method: 'PUT',
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...jsonHeaders,
    },
    credentials: 'include',
    body: JSON.stringify(payload),
  });
  const data = await res.json();
  if (!res.ok) {
    const msg = data?.message || data?.errors?.[0]?.msg || 'Update failed';
    throw new Error(msg);
  }
  return data?.data || null;
}

export async function forgotPassword(email) {
  const res = await fetch(`${API_BASE_URL}/auth/forgot-password`, {
    method: 'POST',
    headers: jsonHeaders,
    credentials: 'include',
    body: JSON.stringify({ email }),
  });
  const data = await res.json();
  if (!res.ok) {
    const msg = data?.message || 'Failed to request reset';
    throw new Error(msg);
  }
  return data;
}

export async function resetPassword(token, password) {
  const res = await fetch(`${API_BASE_URL}/auth/reset-password/${token}`, {
    method: 'POST',
    headers: jsonHeaders,
    credentials: 'include',
    body: JSON.stringify({ password }),
  });
  const data = await res.json();
  if (!res.ok) {
    const msg = data?.message || 'Failed to reset password';
    throw new Error(msg);
  }
  if (data?.token) localStorage.setItem('token', data.token);
  return data;
}
